export default {
	restoringConnection: 'Ühenduse taastamine',
	connectionPreviouslyExisted: 'See ühendus eksisteeris varem ja taastatakse',
	measuresWillBeEnabled: 'meetmeid aktiveeritakse',
	assetAlreadyConnected: 'See vara on juba selle mooduliga ühendatud — palun vali teine vara.',
	assetDuplicateInModule: 'See vara on juba valitud sama mooduli teisele grupile — palun vali teine vara.',
	moduleWillBeActivated: 'Moodul aktiveeritakse',
	withChanges: 'muudatustega',
	noChanges: 'muudatusteta',
	found: 'leitud',
	secNeedWarning: 'turbeviis ületatud',
	importSummary: 'Impordi kokkuvõte',
	detected: 'Tuvastatud',
	attentionRequired: 'Tähelepanu vajavad',
	selected: 'valitud',
	readyToImport: 'valmis importimiseks',
	missingRequirements: 'puuduvad nõuded',
	nameMismatchWarning: 'meetme kirjeldust erineb praegusest standardist — fail võib olla eksporditud teisest versioonist.',
	assetMissing: 'Vara puudub',
	bpMissing: 'Äriprotsess puudub',
	versionMismatch: 'Versioonide erinevus',
	statusMismatch: 'Staatuse mittevastavus',
	responsibleNotFound: 'Vastutaja ei leitud',
	deselectSecurityWarnings: 'Tühista ületavad',
	deselectSecurityWarningsInfo: 'Saad andmed importida, kuid meetmed ei kuvata enne, kui uuendad organisatsiooni turbeviisi.',
	approveVersionMismatch: 'Kinnita versioonierinevus',
	approveVersionMismatchWarning: 'Need meetmed võivad pärineda standardi vanemast versioonist. Palun veendu enne rakendamist, et need vastavad praegusele versioonile.',
	chooseStatusReplacement: 'Asenda staatus',
	required: 'kohustuslik',
	resolveStatusMismatches: 'Jätkamiseks asenda kõik kohandatud staatused',
	noChangesDetected: 'Muudatusi ei tuvastatud',
	dontImport: 'Ära impordi',
	expandAll: 'Ava kõik',
	collapseAll: 'Sulge kõik',
	columnMappingRequired: 'Veergude päiseid ei tuvastatud. Seosta allpool iga faili veerg oodatava väljaga.',
	field: 'Väli',
	columnInFile: 'Veerg failis',
	responsible: 'Vastutaja',
	methodDescription: 'Meetme kirjeldus',
	matchedFromFile: 'Leitud failist',
	matchedFromFileInfo: 'Vara ja/või äriprotsess(id) tuvastati failis oleva nime järgi ja valiti automaatselt.',
	fileAssetNotInSystem: 'Failis: \'{name}\' — süsteemis puudub',
	importNew: 'uued',
	importNotFound: 'ei leitud',
	importPlan: 'Impordi plaan',
}
